import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddStaffDialogComponent } from './add-staff-dialog.component';
import { AddStaffModule } from 'src/app/on-boarding/components/add-staff/add-staff.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmStaffModule } from 'src/app/on-boarding/components/confirm-staff/confirm-staff.module';



@NgModule({
    declarations: [AddStaffDialogComponent],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        MatSidenavModule,
        SharedModule,
        AddStaffModule,
        MatDialogModule,
        ConfirmStaffModule
    ],
    exports: [AddStaffDialogComponent]
})
export class AddStaffDialogModule { }
